import React, { useCallback, useState } from "react";
import { Button } from "../../../components/buttons";
import { AnimationPopup } from "../../../components/modal";
import { ganMienGiamFilterStudentModel } from "../../../models/request/gan-mien-giam/ganMienGiamFilterStudent";
type FilterStudentModalProps = {
    onClose: () => void,
    onSubmit: (filte: ganMienGiamFilterStudentModel) => void,
    filterStudent?: ganMienGiamFilterStudentModel,
    animationOf: string
}
const initialFilter: ganMienGiamFilterStudentModel = {
    cbnv_phenikaa_school: "",
    cbnv_phenikaa: "",
    ac: "",
    hoc_bong: "",
    bus: "",
    ho_khau: ""
}

export const GanMienGiamFilterStudentModal = (props: FilterStudentModalProps) => {
    const [filterStatus, set_filterStatus] = useState<ganMienGiamFilterStudentModel>(props.filterStudent || initialFilter);

    const onClose = useCallback(() => {
        window.animationHidePopup(props.animationOf || "")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [props.animationOf])
    return (
        <AnimationPopup animationOf={props.animationOf} title="Lọc danh sách học sinh"
            maxWidth={800}
        >
            <div>
                <div className="pop-up-form">
                    <div className="row">
                        <div className="col-md-6">
                            <p><b>CBNV Phenikaa School</b></p>
                            <label className={"p-form-radio-cont small-radio primary " + (filterStatus.cbnv_phenikaa_school == "" ? "selected" : "")}>
                                <input type="radio" name="cbnv_phenikaa_school" checked={filterStatus.cbnv_phenikaa_school == ""}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                cbnv_phenikaa_school: ""
                                            }))
                                        }
                                    }} />
                                <span> </span>Tất cả</label>
                            <br />
                            <label className={"p-form-radio-cont small-radio success " + (filterStatus.cbnv_phenikaa_school == "true" ? "selected" : "")}>
                                <input type="radio" name="cbnv_phenikaa_school" checked={filterStatus.cbnv_phenikaa_school == "true"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                cbnv_phenikaa_school: "true"
                                            }))
                                        }
                                    }} />
                                <span> </span>Là con CBNV Phenikaa School</label>  <br />
                            <label className={"p-form-radio-cont small-radio danger " + (filterStatus.cbnv_phenikaa_school == "false" ? "selected" : "")}>
                                <input type="radio" name="cbnv_phenikaa_school" checked={filterStatus.cbnv_phenikaa_school == "false"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                cbnv_phenikaa_school: "false"
                                            }))
                                        }
                                    }} />
                                <span> </span>Không là con CBNV Phenikaa School</label>
                        </div>
                        <div className="col-md-6">
                            <p><b>CBNV Tập đoàn Phenikaa</b></p>
                            <label className={"p-form-radio-cont small-radio primary " + (filterStatus.cbnv_phenikaa == "" ? "selected" : "")}>
                                <input type="radio" name="cbnv_phenikaa" checked={filterStatus.cbnv_phenikaa == ""}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                cbnv_phenikaa: ""
                                            }))
                                        }
                                    }} />
                                <span> </span>Tất cả</label>
                            <br />
                            <label className={"p-form-radio-cont small-radio success " + (filterStatus.cbnv_phenikaa == "true" ? "selected" : "")}>
                                <input type="radio" name="cbnv_phenikaa" checked={filterStatus.cbnv_phenikaa == "true"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                cbnv_phenikaa: "true"
                                            }))
                                        }
                                    }} />
                                <span> </span>Là con CBNV Tập đoàn Phenikaa</label>  <br />
                            <label className={"p-form-radio-cont small-radio danger " + (filterStatus.cbnv_phenikaa == "false" ? "selected" : "")}>
                                <input type="radio" name="cbnv_phenikaa" checked={filterStatus.cbnv_phenikaa == "false"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                cbnv_phenikaa: "false"
                                            }))
                                        }
                                    }} />
                                <span> </span>Không là con CBNV Tập đoàn Phenikaa</label>
                        </div>


                        <div className="col-md-6 padding-top-2rem">
                            <p><b>Anh/Chị học cùng</b></p>
                            <label className={"p-form-radio-cont small-radio primary " + (filterStatus.ac == "" ? "selected" : "")}>
                                <input type="radio" name="ac" checked={filterStatus.ac == ""}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                ac: ""
                                            }))
                                        }
                                    }} />
                                <span> </span>Tất cả</label>
                            <br />
                            <label className={"p-form-radio-cont small-radio success " + (filterStatus.ac == "true" ? "selected" : "")}>
                                <input type="radio" name="ac" checked={filterStatus.ac == "true"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                ac: "true"
                                            }))
                                        }
                                    }} />
                                <span> </span>Có Anh/Chị học cùng</label>  <br />
                            <label className={"p-form-radio-cont small-radio danger " + (filterStatus.ac == "false" ? "selected" : "")}>
                                <input type="radio" name="ac" checked={filterStatus.ac == "false"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                ac: "false"
                                            }))
                                        }
                                    }} />
                                <span> </span>Không có Anh/chị học cùng</label>
                        </div>


                        <div className="col-md-6 padding-top-2rem">
                            <p><b>Đăng ký đi xe</b></p>
                            <label className={"p-form-radio-cont small-radio primary " + (filterStatus.bus == "" ? "selected" : "")}>
                                <input type="radio" name="bus" checked={filterStatus.bus == ""}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                bus: ""
                                            }))
                                        }
                                    }} />
                                <span> </span>Tất cả</label>
                            <br />
                            <label className={"p-form-radio-cont small-radio success " + (filterStatus.bus == "true" ? "selected" : "")}>
                                <input type="radio" name="ac" checked={filterStatus.bus == "true"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                bus: "true"
                                            }))
                                        }
                                    }} />
                                <span> </span>Có đăng ký đi xe</label>  <br />
                            <label className={"p-form-radio-cont small-radio danger " + (filterStatus.bus == "false" ? "selected" : "")}>
                                <input type="radio" name="bus" checked={filterStatus.bus == "false"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                bus: "false"
                                            }))
                                        }
                                    }} />
                                <span> </span>Không đăng ký đi xe</label>
                        </div>
                        <div className="col-md-6 padding-top-2rem">
                            <p><b>Đạt học bổng</b></p>
                            <label className={"p-form-radio-cont small-radio primary " + (filterStatus.hoc_bong == "" ? "selected" : "")}>
                                <input type="radio" name="hoc_bong" checked={filterStatus.hoc_bong == ""}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                hoc_bong: ""
                                            }))
                                        }
                                    }} />
                                <span> </span>Không lọc theo học bổng</label>
                            <br />
                            <label className={"p-form-radio-cont small-radio success " + (filterStatus.hoc_bong == "50" ? "selected" : "")}>
                                <input type="radio" name="hoc_bong" checked={filterStatus.hoc_bong == "50"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                hoc_bong: "50"
                                            }))
                                        }
                                    }} />
                                <span> </span>Đạt HB 50%</label>  <br />
                            <label className={"p-form-radio-cont small-radio success " + (filterStatus.hoc_bong == "80" ? "selected" : "")}>
                                <input type="radio" name="hoc_bong" checked={filterStatus.hoc_bong == "80"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                hoc_bong: "80"
                                            }))
                                        }
                                    }} />
                                <span> </span>Đạt HB 80%</label>
                            <br />
                            <label className={"p-form-radio-cont small-radio success " + (filterStatus.hoc_bong == "100" ? "selected" : "")}>
                                <input type="radio" name="hoc_bong" checked={filterStatus.hoc_bong == "100"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                hoc_bong: "100"
                                            }))
                                        }
                                    }} />
                                <span> </span>Đạt HB 100%</label>
                        </div>
                        <div className="col-md-6 padding-top-2rem">
                            <p><b>Lọc theo hộ khẩu</b></p>
                            <label className={"p-form-radio-cont small-radio primary " + (filterStatus.ho_khau == "" ? "selected" : "")}>
                                <input type="radio" name="ho_khau" checked={filterStatus.ho_khau == ""}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                ho_khau: ""
                                            }))
                                        }
                                    }} />
                                <span> </span>Tất cả</label>
                            <br />
                            <label className={"p-form-radio-cont small-radio success " + (filterStatus.ho_khau == "true" ? "selected" : "")}>
                                <input type="radio" name="ho_khau" checked={filterStatus.ho_khau == "true"}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            set_filterStatus(Object.assign({}, filterStatus, {
                                                ho_khau: "true"
                                            }))
                                        }
                                    }} />
                                <span> </span>Có hộ khẩu Từ Liêm hoặc Hoài Đức</label>  <br />

                        </div>
                    </div>
                </div>
                <div className="pop-up-actions">
                    <Button onClick={onClose} type="normal" text="Đóng" />{' '}
                    <Button onClick={() => { props.onSubmit(initialFilter) }} type="danger" text="Bỏ lọc" /> {' '}
                    <Button onClick={() => { props.onSubmit(filterStatus) }} type="normal" text="Áp dụng" />

                </div>
            </div>
        </AnimationPopup>
    );
}